import $ from 'jquery';
// import mpro from './mpro.init';

import { applyComponentClickRestrictions } from '../../util/plugin.js';
import { getOptionsFromDataset } from '../../util/dataset.js';

import MpDialog from '../../modules/components/dialog.js';


// Export helpers to mpro namespace
mpro.ask = MpDialog.ask.bind(MpDialog);
mpro.confirm = MpDialog.confirm.bind(MpDialog);
mpro.alert = MpDialog.alert.bind(MpDialog);

// TODO: use addInitStatic with priority flag (to be implemented)

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {
	// Find all confirm elements
	mpro.handleConfirmDialog($container.find('[data-confirm]'));
});

/**
 * @param {JQuery | HTMLElement | HTMLElement[]} items
 */
mpro.handleConfirmDialog = (items) => {

	/** @type {JQuery} */// @ts-ignore
	const $items = items instanceof $ ? items : $(items);

	if ($items.length > 0) {

		$items.off('click.mp-confirm').on('click.mp-confirm', function(e) {

			/** @type {HTMLElement} */
			const confirmTrigger = this;

			// Disabled element
			if (confirmTrigger.classList.contains('disabled')) {
				return;
			}

			// @ts-ignore
			const evtData = e.originalEvent.data;

			// Action already confirmed - pass through
			if (evtData && (evtData.confirmed === true)) {
				return;
			}

			const options = getOptionsFromDataset(confirmTrigger, 'confirm', true);

			// Standard component click restrictions
			if (applyComponentClickRestrictions('confirm', options, e) === false) {
				return;
			}

			// Prevent any further action
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();

			// Close all other dialogs
			// MpDialog.closeAll({ dismissible: true });

			// Close dropdowns/tooltips/popovers
			mpro.closeSimpleOverlays();

			const $elem = $(confirmTrigger);
			const confirmTitle = ($elem.attr('data-bs-original-title') || $elem.attr('title') || $elem.text()).trim() || void 0; // <-- let it fallback to data-confirm-* attributes
			const confirmContent = (typeof confirmTrigger.dataset.confirm === 'string') && confirmTrigger.dataset.confirm || void 0; // <-- let it fallback to data-confirm-* attributes

			// Display the instance
			MpDialog.confirm({
				relatedTarget: confirmTrigger,
				skipDataset: true,
				title: confirmTitle,
				content: confirmContent,
				...options,
				url: null, // <-- make sure the dialog doesn't inherit any url
				okAction: (dialog) => {

					// Close the dialog window
					dialog.hide();

					// Create our event (with options)
					const evt = new MouseEvent('click', {
						bubbles: true,
						cancelable: true,
						view: window,
					});

					// @ts-ignore
					evt.data = { confirmed: true };

					// Dispatch the click event again
					confirmTrigger.dispatchEvent(evt);

					// Dispatch custom event
					$elem.triggerNative('mp-confirm-dialog');
				},
			});
		});
	}
};

export default mpro;
